import { LowerCasePipe, UpperCasePipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { OnyxAvatarComponent, OnyxDatePipe } from '@onyx/angular';
import type { CompanyData } from '../../../../../../common/interfaces/data-providers/company-data';
import type { Contractor } from '../../interfaces/contractor';

@Component({
  selector: 'app-contractor-cell',
  imports: [
    OnyxAvatarComponent,
    TranslatePipe,
    LowerCasePipe,
    OnyxDatePipe,
    UpperCasePipe,
  ],
  templateUrl: './contractor-cell.component.html',
  styleUrl: './contractor-cell.component.scss',
})
export class ContractorCellComponent {
  public readonly companyProfile = input.required<
    Contractor['companyProfile'] | null
  >();
  public readonly companyData = input.required<CompanyData | null>();
  public readonly showSince = input(false);
}
